// 模板-套打
/**
 * @param {*} printData 打印数据
 * @param {*} printTemplate 打印模板
 */
const hiprintNest = function (printData, printTemplate, pdfName) {
	var testhiprintTemplate = new hiprint.PrintTemplate({
		template: printTemplate.tableTemp,
	});
	// testhiprintTemplate.print(printData);
	// console.log("testhiprintTemplate", printData, printTemplate);
	testhiprintTemplate.toPdf(printData, pdfName + ".pdf", {scale:4 });
};

export default hiprintNest;
